// src/utils/lineId.js

// Stable stringify (keys sorted, arrays stable) so the same options
// always produce the same string, regardless of object key order.
export const stableStringify = (obj) => {
  if (obj == null) return "";
  if (typeof obj !== "object") return String(obj);
  if (Array.isArray(obj)) return `[${obj.map(stableStringify).join(",")}]`;
  return `{${Object.keys(obj)
    .sort()
    .map((k) => `${k}:${stableStringify(obj[k])}`)
    .join(",")}}`;
};

// Tiny, fast, deterministic hash for the options blob.
// We only need uniqueness within a cart/session, not crypto strength.
export const hash = (str) => {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) | 0;
  return Math.abs(h).toString(36);
};

// Build a stable lineId from product + selected options.
// IMPORTANT: `options` should only include identity-defining selections
// (e.g., sizeId, flavorId, color, and minimal customizations). Never
// include mutable fields like quantity, price, or images.
export const buildLineId = ({ productId, type, options }) => {
  const opts = stableStringify(options || {});
  return `prod:${productId}|type:${type || "na"}|opts:${hash(opts)}`;
};
